import { getPreviousDate, stringToDate} from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { pricingChangesEndDate, pricingChangesEvolutionCurrentPeriod } from "../@signals"


export const rangeDatesPricingChanges = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, pricingChangesEndDate.value), getPreviousDate({ days: 1 }, pricingChangesEndDate.value)] },
        placement: 'left',
        onFocus: () => pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 6 }, pricingChangesEndDate.value), stringToDate(pricingChangesEndDate.value)] },
        placement: 'left',
        onFocus: () => pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 29 }, pricingChangesEndDate.value), stringToDate(pricingChangesEndDate.value)] },
        placement: 'left',
        onFocus: () => pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(pricingChangesEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(pricingChangesEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]